import React from "react"
import "@formatjs/intl-relativetimeformat/polyfill"
import "@formatjs/intl-relativetimeformat/dist/locale-data/en"

import Layout from "./index"

export default props => (
  <Layout {...props} i18nMessages="Select your language" />
)
